import { createSlice } from "@reduxjs/toolkit";
const token = localStorage.getItem("token");
const storedResolvedPermissions = localStorage.getItem("resolvedPermissions");

export const userSlice = createSlice({
  name: "user",
  initialState: {
    authenticated: token ? true : false,
    roles: [],
    permissions: [],
    oragnizations: [],
    // Cached so a refresh can render routes on the first paint instead of
    // waiting on permission_lookup.
    resolvedPermissions: storedResolvedPermissions
      ? JSON.parse(storedResolvedPermissions)
      : null,
  },
  reducers: {
    login: (state, action) => {
      localStorage.setItem("token", JSON.stringify(action.payload.access));
      localStorage.setItem(
        "permissions",
        JSON.stringify(action.payload.permissions)
      );
      localStorage.setItem("roles", JSON.stringify(action.payload.roles));
      localStorage.setItem("clientID", JSON.stringify(action.payload.clientID));
      localStorage.setItem(
        "firstName",
        JSON.stringify(action.payload.firstName)
      );
      localStorage.setItem("lastName", JSON.stringify(action.payload.lastName));
      localStorage.setItem(
        "organizations",
        JSON.stringify(action.payload.organizations)
      );
      return action.payload;
    },
    logout: (state, action) => {
      localStorage.removeItem("token");
      localStorage.removeItem("permissions");
      localStorage.removeItem("lastName");
      localStorage.removeItem("firstName");
      localStorage.removeItem("clientID");
      localStorage.removeItem("roles");
      localStorage.removeItem("organizations");
      localStorage.removeItem("resolvedPermissions");
      return {
        authenticated: false,
      };
    },
    userAccessLevel: (state, action) => {
      if (action.payload.resolvedPermissions) {
        localStorage.setItem(
          "resolvedPermissions",
          JSON.stringify(action.payload.resolvedPermissions)
        );
      }
      let payload = {};
      return { ...state, ...action.payload, ...payload };
    },
  },
});

export default userSlice.reducer;
const login = userSlice.actions.login;
const logout = userSlice.actions.logout;
const userAccessLevel = userSlice.actions.userAccessLevel;

export { login, logout, userAccessLevel };
